import { Typography, } from '@mui/material';

const ConfidentialityPage = () => {
    return (
        <>
            <Typography
                sx={{
                    fontSize: [18, 21, 24, 27],
                    fontWeight: 700,
                    mb: [3, 4, 5, 6], }}>Политика конфиденциальности</Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 14, }}>Данная страница находится в разработке</Typography>
        </>
    );
};

export default ConfidentialityPage;